import { useFragment } from '@apollo/client';

import {
  ProductDetailsProductStats,
  ProductDetailsProductStatsSkeleton,
} from '@components/product/ProductDetailsProductStats';

import {
  ProductDetailsProductStatsFragment,
  ProductDetailsProductStatsFragmentDoc,
} from './gql/graphql.v3.generated';

type Product = {
  __typename?: 'ProductDetails',
  id: number,
}

interface Props {
  className?: string,
  product?: Product,
}

export const ProductDetailsProductStatsContainer: React.FC<Props> = ({
  className,
  product,
}) => {
  const { data, complete } = useFragment<ProductDetailsProductStatsFragment>({
    fragment: ProductDetailsProductStatsFragmentDoc,
    from: product || null,
  });

  if (!complete) {
    return (
      <ProductDetailsProductStatsSkeleton className={className} />
    );
  }

  if (data) {
    return (
      <ProductDetailsProductStats
        className={className}
        impressionsCount={data.impressionsCount || 0}
        paidImpressionsCount={data.paidImpressionsCount || 0}
        viewsCount={data.viewsCount || 0}
        likesCount={data.likes || 0}
        availabilityCount={data.availabilityCount || 0}
      />
    );
  }

  return null;
};
